import { useEffect } from 'react'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'

export function useAuth() {
  const qc = useQueryClient()

  useEffect(() => {
    const { data: subscription } = supabase.auth.onAuthStateChange(() => {
      qc.invalidateQueries({ queryKey: ['session'] })
      qc.invalidateQueries({ queryKey: ['resident-profile'] })
    })
    return () => subscription.subscription.unsubscribe()
  }, [qc])

  const { data: session, isLoading: sessionLoading } = useQuery({
    queryKey: ['session'],
    queryFn: async () => {
      const { data } = await supabase.auth.getSession()
      return data.session
    },
  })

  const { data: profile, isLoading: profileLoading } = useQuery({
    queryKey: ['resident-profile', session?.user?.id],
    enabled: !!session,
    queryFn: async () => {
      const { data, error } = await supabase
        .from('residents')
        .select(`
          *,
          barangay:entities!residents_barangay_entity_id_fkey(id, name, status, psgc_code),
          purok:puroks(id, name)
        `)
        .eq('id', session!.user.id)
        .maybeSingle()
      if (error) throw error
      return data
    },
  })

  return {
    session,
    profile,
    isLoading: sessionLoading || profileLoading,
    isAuthenticated: !!session,
    needsOnboarding: !!session && !profile,
  }
}
